import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { films } from "@/mocks/films";

export default function FeaturedTopics() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
      {topics.map((topic) => {
        const count = new Set(topic.groups.flatMap((g) => g.filmIds)).size;
        const previewFilms = topic.groups.flatMap((g) => g.filmIds).slice(0, 3);
        return (
          <Link
            key={topic.id}
            to={`/topic/${topic.id}`}
            className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
              <img
                src={topic.cover}
                alt={`${topic.title} 专题主图`}
                title={`${topic.title} - 欧美伦理专题`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent"></div>
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-[11px] font-semibold bg-accent-500 text-foreground-950">
                精选专题
              </span>
              <div className="absolute bottom-3 left-3 right-3">
                <h3 className="font-heading font-bold text-lg md:text-xl text-background-50 leading-snug line-clamp-2">
                  {topic.title}
                </h3>
              </div>
            </div>
            <div className="flex-1 p-5">
              <p className="text-xs font-medium text-accent-600 mb-2">{topic.subtitle}</p>
              <p className="text-sm leading-relaxed text-foreground-600 line-clamp-2">{topic.intro}</p>
              <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
                <div className="flex items-center gap-2">
                  <div className="flex -space-x-2">
                    {previewFilms.map((id) => {
                      const f = films.find((item) => item.id === id);
                      if (!f) return null;
                      return (
                        <span
                          key={id}
                          className="w-7 h-7 rounded-md overflow-hidden border border-background-50 bg-background-200"
                        >
                          <img src={f.poster} alt={f.title} className="w-full h-full object-cover object-top" />
                        </span>
                      );
                    })}
                  </div>
                  <span className="text-xs text-foreground-500">共 {count} 部作品</span>
                </div>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:gap-2 transition-all">
                  查看专题
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}